
<template>
  <div>
    <IKFiltroFuncionario ref="ikFiltroFuncionario"/> 
    <h6 class="p-text-bold">Período</h6>  
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col">
            <label>Dia início</label>
            <Calendar v-model="dataInicio" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>				
        </div>
        <div class="p-field p-col">
            <label>Dia final</label>
            <Calendar v-model="dataFinal" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>	
        </div>
    </div>
    <div class="p-d-flex p-jc-left">
        <Button label="Gerar PDF" icon="pi pi-file-pdf" class="p-mt-3 p-mr-2" 
        @click="processar" :disabled="bloquearEnivo"/>
        <IKMonitoramentoDocumentos  ref="ikMonitoramentoDocumentos" :callback="finalizar"/>
    </div>    
  </div>
</template>

<script>
import RelatorioService from '@/service/RelatorioService';
import IKFiltroFuncionario from '@/components/template/IKFiltroFuncionario';
import IKMonitoramentoDocumentos from '@/components/template/IKMonitoramentoDocumentos';
import { exibirMensagem, exibirMensagemSis, localeCalendarBR } from '@/global';
import { mapGetters } from 'vuex';

export default {
    relatorioService: null,
    data() {
        return {
            bloquearEnivo: false,           
            dataInicio: new Date(),
            dataFinal: new Date(),
            localeCalendarBR: localeCalendarBR
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),    
        /**
         * 
         */
        processar() {
            let dados = this.$refs.ikFiltroFuncionario.getFuncionarios();            
            if(dados.funcionarios.length == 0) {
                exibirMensagemSis(this, 'Selecione um ou mais funcionários', true);
                return;
            }
            let idsFuncionarios = [];
            dados.funcionarios.forEach(funcio => {
                idsFuncionarios.push(funcio.id);
            });
            let requisicao = {              
                dataInicio: this.formatarData(this.dataInicio),
                dataFinal: this.formatarData(this.dataFinal),
                idsFuncionarios: idsFuncionarios,
                idsCentrosCustos: dados.idsCentrosCustos,
                ativo: dados.ativo,
                cnpj: {...dados.cnpj},
                todos: false,
                nomeDocumento: 'Horas Trabalhadas',
                nomeArquivo: 'Horas_Trabalhadas',
                servico: 'horasTrabalhadas',
                tipoDocumento: 'pdf',
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }
            this.relatorioService.processar(requisicao)
            .then(resp => {     
                this.bloquearEnivo = true;
                this.$refs.ikMonitoramentoDocumentos.iniciarMonitoramento(resp.data);             
            })
            .catch(erro => {exibirMensagem(this, erro)});
        },
        /**
         * 
         */
        finalizar() {            
            this.bloquearEnivo = false;
        },
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		}
    },
    created() {
        this.relatorioService = new RelatorioService();
    },
    components: {
        'IKFiltroFuncionario': IKFiltroFuncionario,        
        'IKMonitoramentoDocumentos': IKMonitoramentoDocumentos
    }
}
</script>

<style>

</style>